import { render } from "./PaymentSplitTrendChart.vue?vue&type=template&id=58c5cafc&scoped=true"
import script from "./PaymentSplitTrendChart.vue?vue&type=script&lang=js"
export * from "./PaymentSplitTrendChart.vue?vue&type=script&lang=js"

import "./PaymentSplitTrendChart.vue?vue&type=style&index=0&id=58c5cafc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c5cafc"]])

export default __exports__